import React, { useState } from 'react'
import { Card, List } from 'antd'
import { api } from 'xadmin'
import { moment } from 'moment'
const NodeRecord = (props) => {
  const { id, limit } = props
  const [ items, setItems ] = useState([])

  React.useEffect(()=>{
    initNodeRecord(id)
    setInterval(()=>{
      initNodeRecord(id)
    }, 5000)
  },[ id ])

  const initNodeRecord = (id) => {
    let query = {
      'sort': { 'time': -1 },
      'skip': 0,
      'limit': limit && Number(limit) || 5,
      'project': { 'time': 1,'node': 1,'department': 1,'user': 1,'type': 1,'message': 1,'data': 1 },
      'filter': { 'nodeId': id },
      'withCount': true
    }
    let queryStr = encodeURIComponent(JSON.stringify(query))
    api({ name: 'core/record' })
      .fetch('?query='+queryStr, {})
      .then(({ json })=>{
        setItems(json)
      })
  }

  return (
    <Card>
      <List
        size="small"
        dataSource={items}
        renderItem={(item, index)=>(  
          <List.Item>
            {
              <div style={{ width: '100%' }}>
                <div style={{ display: 'flex' }}>
                  <p style={{ flex: 1 }}>
                    <span style={{ fontSize: '13px', fontFamily:'PingFangSC-Medium',fontWeight:500,color:'rgba(48,48,48,1)' }}>
                      <img src={require('./../icon/homeIcon/notePeople.png')} />
                      <span style={{ padding: '0 25px 0 10px' }}>{item.user.name}</span>     
                    </span>
                    <span style={{ fontSize: '13px', fontFamily:'PingFangSC-Regular',fontWeight:400,color:'rgba(48,48,48,1)' }}>{item.node.name}</span></p>
                  <p style={{ flex: 1, textAlign: 'right' }}>
                    {
                      item.department && item.department.map(v=>{
                        return <span key={v.id}>{v.name}</span>
                      })
                    }
                    {/* <span style={{ paddingLeft: '.8rem' }}>{ item.time ? item.time : null}</span> */}
                  </p>
                </div>
                <div style={{ fontSize: '13px', fontFamily:'PingFangSC-Regular',fontWeight:400,color:'rgba(131,131,131,1)' }}>{item.data}</div>
              </div>
            }
          </List.Item>
        ) 
        }/>
    </Card>
  )
}

export default NodeRecord
